import Vue from 'vue'
import Vuex from 'vuex'

import menus from './modules/menus'
import baseData from '../common/apis/baseData.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        pubParams: []
    },
    mutations: {},
    actions: {
        commonActions({state}) {
            //台账下拉框公共行别
            /*baseData.getParams({}).then(res => {
                state.pubParams = res.data.list || []
            })*/
            state.pubParams = [
                {code: "ADDRESS", value: "昆明市官渡区金马街道办事处世纪名汇商业中心(一期4号楼4层418号)"},
                {code: "PHONE", value: "19156076698"},
                {code: "EMAIL", value: "398305246@qq.com"},
                {code: "WECHAT", value: "yudg8888"}
            ]
        }
    },
    modules: {
        menus
    }
})
